// css modules
import styles from './App.scss';

// node_modules
import React, { useEffect, useRef } from 'react';

// root imports
import { GridContainerThemeProvider } from 'src/components/GridContainerThemeProvider/GridContainerThemeProvider';
import { useCaptureScrollbar } from 'src/hooks/UseCaptureScrollbar';
import { setExistingMerchantCookieWithSubDomains } from 'src/utils/ExistingMerchant';

// relative imports
import { useTranslation } from 'react-i18next';
import { CookieBanner } from '../CookieBanner/CookieBanner';
import { ScrollHandler } from '../ScrollHandler/ScrollHandler';
import { SiteFooterV2 } from '../SiteFooterV2/SiteFooterV2';
import { SiteHeader } from '../SiteHeader/SiteHeader';
import { SkipNav } from '../SkipNavigation/SkipNav';
import { InternationalRedirects } from './Routes/InternationalRedirects/InternationalRedirects';
import { Routes } from './Routes/Routes';

export const App: React.FC = () => {
  const mainWrapper = useRef(null);
  const { i18n } = useTranslation();

  useEffect(() => {
    setExistingMerchantCookieWithSubDomains();
  }, []);

  useCaptureScrollbar();

  return (
  <GridContainerThemeProvider>
    <div className={styles.app}>
      <InternationalRedirects>
        <SkipNav id="skip-nav" targetDomId="main" />
        <ScrollHandler />
        <SiteHeader mainContentRef={mainWrapper} />
        <div id="main" ref={mainWrapper} className={styles.mainWrapper} role="main">
          {i18n.language !== 'en-US' && (
            <CookieBanner />
          )}
          <div className={styles.main}>
            <Routes />
          </div>
        </div>
        <SiteFooterV2 />
      </InternationalRedirects>
    </div>
  </GridContainerThemeProvider>
  );
};
